const actionTypes = {
    DISPLAY_DRAWER_MENU: 'DISPLAY_DRAWER_MENU',

    REQUEST_CLIENTS: 'REQUEST_CLIENTS',
    RECEIVE_CLIENTS_SUCCESS: 'RECEIVE_CLIENTS_SUCCESS'
};

export default actionTypes;